const mapsKeyElement = document.querySelector('meta[name="config:keys.google-maps"]');
const googleApiKey = mapsKeyElement ? mapsKeyElement.content : undefined;

/**
 * Google API Key
 * @type {string}
 */
export const GOOGLE_API_KEY = googleApiKey;



// WEBPACK FOOTER //
// ./client/src/vendor/google-maps-api/config.js